import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpParams,
    HttpRequest,
    HttpUrlEncodingCodec,
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

class AppHttpParameterCodec extends HttpUrlEncodingCodec {
    /**
     * Removes leading and trailing whitespace from request params
     */
    override encodeValue(value: string): string {
        // add more transformations to request params here if necessary
        return super.encodeValue(value.trim());
    }
}
/**
 * Encodes request parameters
 */
@Injectable()
export class HttpParameterInterceptor implements HttpInterceptor {
    protected readonly encoder = new AppHttpParameterCodec();

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.params?.keys().length) {
            const clonedReq = req.clone({
                params: new HttpParams({fromString: req.params.toString(), encoder: this.encoder}),
            });
            return next.handle(clonedReq);
        } else {
            return next.handle(req);
        }
    }
}
